import {
  IconPublic,
  IconClock,
  IconSync,
  IconSalary,
  IconPartTime,
  IconMiniJob,
} from '@xing-com/icons';
import {
  xdlColorCardInspire03,
  xdlColorCardInspireText03,
  xdlPalettePetrol02,
  xdlPalettePetrol09,
  xdlPaletteMint10,
  xdlPaletteLime02,
} from '@xing-com/tokens';

export const INSPIRATIONAL_CARDS_DATA = [
  {
    icon: IconPublic,
    title: 'TITLE_CARD_1_CAREER_HUB',
    description: 'DESCRIPTION_CARD_1_CAREER_HUB',
    link: 'https://www.xing.com/jobs/search?remoteOption=FULL_REMOTE.050e26',
    backgroundColor: xdlColorCardInspire03,
    textColor: xdlColorCardInspireText03,
    trackingParam: {
      sc_o: 'career_hub_application_home_inspirational_card_click',
      sc_o_PropActionOrigin:
        'career_hub_application_home_inspirational_card_remote_work',
    },
  },
  {
    icon: IconClock,
    title: 'TITLE_CARD_2_CAREER_HUB',
    description: 'DESCRIPTION_CARD_2_CAREER_HUB',
    link: 'https://www.xing.com/jobs/search?benefit=1.795d28',
    backgroundColor: xdlPalettePetrol02,
    textColor: xdlPalettePetrol09,
    trackingParam: {
      sc_o: 'career_hub_application_home_inspirational_card_click',
      sc_o_PropActionOrigin:
        'career_hub_application_home_inspirational_card_flexible_work',
    },
  },
  {
    icon: IconSync,
    title: 'TITLE_CARD_3_CAREER_HUB',
    description: 'DESCRIPTION_CARD_3_CAREER_HUB',
    link: 'https://www.xing.com/jobs/t-quereinsteiger?keywords=Quereinsteiger ',
    backgroundColor: xdlPaletteLime02,
    textColor: xdlPaletteMint10,
    trackingParam: {
      sc_o: 'career_hub_application_home_inspirational_card_click',
      sc_o_PropActionOrigin:
        'career_hub_application_home_inspirational_card_career_change',
    },
  },
  {
    icon: IconSalary,
    title: 'TITLE_CARD_4_CAREER_HUB',
    description: 'DESCRIPTION_CARD_4_CAREER_HUB',
    link: 'https://login.xing.com?signup_channel=careerhub',
    backgroundColor: xdlPalettePetrol02,
    textColor: xdlPalettePetrol09,
    trackingParam: {
      sc_o: 'career_hub_application_home_inspirational_card_click',
      sc_o_PropActionOrigin:
        'career_hub_application_home_inspirational_card_top_salary',
    },
  },
  {
    icon: IconPartTime,
    title: 'TITLE_CARD_5_CAREER_HUB',
    description: 'DESCRIPTION_CARD_5_CAREER_HUB',
    link: 'https://www.xing.com/jobs/search?employmentType=PART_TIME.58889d',
    backgroundColor: xdlPaletteLime02,
    textColor: xdlPaletteMint10,
    trackingParam: {
      sc_o: 'career_hub_application_home_inspirational_card_click',
      sc_o_PropActionOrigin:
        'career_hub_application_home_inspirational_card_part_time',
    },
  },
  {
    icon: IconMiniJob,
    title: 'TITLE_CARD_6_CAREER_HUB',
    description: 'DESCRIPTION_CARD_6_CAREER_HUB',
    link: 'https://www.xing.com/jobs/search?employmentType=TEMPORARY.8ff6ad',
    backgroundColor: xdlColorCardInspire03,
    textColor: xdlColorCardInspireText03,
    trackingParam: {
      sc_o: 'career_hub_application_home_inspirational_card_click',
      sc_o_PropActionOrigin:
        'career_hub_application_home_inspirational_card_minijobs',
    },
  },
];
